import React from 'react'
import { Layout, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

const { Content } = Layout

interface LoadingScreenProps {
  message?: string
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = 'Loading...' 
}) => {
  return (
    <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Content style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center',
        padding: '48px'
      }}>
        <Spin 
          indicator={<LoadingOutlined style={{ fontSize: 48, color: '#1890ff' }} spin />}
          style={{ marginBottom: '24px' }}
        />
        <h2 style={{ 
          color: '#1890ff', 
          marginBottom: '8px',
          textAlign: 'center'
        }}>
          ServiceFlow Pro
        </h2>
        <p style={{ 
          color: '#666', 
          fontSize: '16px',
          textAlign: 'center',
          margin: 0
        }}>
          {message}
        </p>
      </Content>
    </Layout>
  )
}
